<template>
	<div class="form-container">
		<h2 class="form-title">
			새로 이용하실<br />
			비밀번호를 2회 입력하세요.
		</h2>

		<form @submit.prevent="onSubmitForm">
			<div class="form-group" :class="{ 'has-error': validMessage.newPassword }">
				<label class="form-label">새 비밀번호</label>

				<div class="columns">
					<div class="column col-12">
						<input
							v-model="newPassword"
							class="form-input"
							type="password"
							placeholder="영문 대소문자, 숫자, 특수문자 중 2종류 이상 조합으로 이루어진 8~16자"
						/>
						<FormInputHint :message="validMessage.newPassword"></FormInputHint>
					</div>
				</div>
			</div>

			<div
				class="form-group"
				:class="{ 'has-error': validMessage.reNewPassword }"
			>
				<label class="form-label">새 비밀번호 확인</label>

				<div class="columns">
					<div class="column col-12">
						<input
							v-model="reNewPassword"
							class="form-input"
							type="password"
							placeholder="새 비밀번호를 한번 더 확인하세요"
						/>
						<FormInputHint :message="validMessage.reNewPassword"></FormInputHint>
					</div>
				</div>
			</div>

			<div class="form-group form-button">
				<BaseBtn type="submit" color="primary" x-large block
					>비밀번호 변경</BaseBtn
				>
			</div>
		</form>
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';

import BaseBtn from '@/components/common/Btn';
import FormInputHint from '@/components/common/FormInputHint';

import validation from '@/utils/validation';

export default {
	mixins: [mixin],
	components: {
		BaseBtn,
		FormInputHint,
	},
	data() {
		return {
			newPassword: '',
			reNewPassword: '',

			// 유효성 검사
			validMessage: {},
		};
	},
	computed: {
		updateUserInfo() {
			return this.$store.getters['findPasswordStore/updateUserInfo'];
		},
	},
	watch: {
		newPassword(val) {
			this.validMessage.newPassword = validation.getValidUserPw(
				val,
				this.updateUserInfo.user_id,
			);
			this.validMessage.reNewPassword = validation.getValidReUserPw(
				this.reNewPassword,
				val,
			);
		},
		reNewPassword(val) {
			this.validMessage.reNewPassword = validation.getValidReUserPw(
				val,
				this.newPassword,
			);
		},
	},
	methods: {
		isValidMessage() {
			let isValidMessage = false;

			for (const property in this.validMessage) {
				if (this.validMessage[property]) {
					isValidMessage = true;
					break;
				}
			}
			return isValidMessage;
		},
		async onSubmitForm() {
			// 유효성 검사
			if (!this.newPassword || !this.reNewPassword || this.isValidMessage()) {
				const message = '비밀번호를 올바르게 입력했는지 확인해주세요.';
				const options = {
					message,
				};
				this.showAlert(options);

				return false;
			}

			const payload = {
				userId: this.updateUserInfo.user_id,
				userName: this.updateUserInfo.user_name,
				userHp: this.updateUserInfo.user_hp,
				certId: this.updateUserInfo.cert_id,
				newPassword: this.newPassword,
				reNewPassword: this.reNewPassword,
			};

			const { data } = await this.$store.dispatch(
				'findPasswordStore/updateUserPassword',
				payload,
			);

			if (data.code === '00000') {
				this.$emit('nextPage');
			} else {
				const options = {
					message: data.message || '비밀번호 변경에 실패했습니다.',
				};
				this.showAlert(options);
			}
		},
	},
};
</script>
